module.exports = __webpack_public_path__ + "img/34.66de0a89.jpg";